import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import ActionButton from "./formInputs/buttons/ActionButton.jsx";

import { GlobalContext } from "./contextProvider/ContextProvider";
import { isUserDistrictAdmin, isUserSchoolAdmin } from "../utils/isUser.jsx";

import "../styles/Toolbar.scss";

const Toolbar = () => {
    const { state } = useContext(GlobalContext);
    const { userDetails } = state || {};
    const { location } = userDetails || {};
    const [isDistrict, setIsDistrict] = useState(false);
    const [isSchoolAdmin, setIsSchoolAdmin] = useState(false);

    const navigate = useNavigate();

    /* Determine if user is district admin or school admin */
    useEffect(() => {
        if (isUserDistrictAdmin(userDetails)) {
            setIsDistrict(true);
        }
        if (isUserSchoolAdmin(userDetails)) {
            setIsSchoolAdmin(true);
        }
    }, [userDetails]);

    return (
        <div className="toolbar">
            <div className="tb-content-wrapper">
                <Link className="toolbar-link-home" to="/home">
                    EPR
                </Link>{" "}
                <div className="divider"></div>
                {isSchoolAdmin && !isDistrict && <span>{location}</span>}
                {isDistrict && <span>District Admin</span>}
            </div>
            {isDistrict && (
                <ActionButton className="ghost-button-reg" label="Admin Home" onClick={() => navigate("/home")} />
            )}
        </div>
    );
};

export default Toolbar;
